"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindDocumentVesionsInput = void 0;
const class_validator_1 = require("class-validator");
class FindDocumentVesionsInput {
}
__decorate([
    (0, class_validator_1.IsEnum)([
        'DRIVER_LICENSE',
        'CARTE_GRISE',
        'VTC_CARD',
        'VTC_REGISTER_CERTIFICATE',
        'RIR',
        'TRAFFIC_PROFESSIONAL_CIVIL_LIABILITY',
        'OPERATIONAL_CIVIL_LIABILITY',
        'TECHCNICAL_CONTROL',
        'RIB',
        'KBIS',
        'VMDTR_CARD',
        'TRAVELER_CAPACITY_LICENSE',
        'TAXI_CARD',
        'YELLOW_CARD',
        'METROLOGICAL_CARD',
        'TRAINING_CERTIFICATE',
        'PARKING_AUTHORIZATION',
        'TPMR',
    ]),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FindDocumentVesionsInput.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FindDocumentVesionsInput.prototype, "parentid", void 0);
exports.FindDocumentVesionsInput = FindDocumentVesionsInput;
